<div class="data-protection-rules">

    <sc-master-detail [selection]="[selectedRule]" [data]="rules"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);" [newStyle]="true"
        (deleteEntry)="onDeleteEntry($event);">

        <div class="data-protection-rule-details">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
            <div class="form-box" [formGroup]="detailsForm">

                <sc-flex vertical stretchContent>

                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
                      </mat-label>
                        <input matInput name="name" formControlName="name"
                            [required]="true" [maxLength]="255">
                    </mat-form-field>

                    <mat-checkbox class="form-checkbox" name="defaultRule" formControlName="defaultRule">
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.default-rule"></sc-dictionary-label>
                    </mat-checkbox>

                    <mat-checkbox class="form-checkbox" name="disabled" formControlName="disabled">
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.disabled"></sc-dictionary-label>
                    </mat-checkbox>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="phoneEnabled"
                            formControlName="phoneEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.phone"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="phone" formControlName="phone"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="numberPlateEnabled"
                            formControlName="numberPlateEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.numberplate"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="numberPlate" formControlName="numberPlate"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="trailerNumberPlateEnabled"
                            formControlName="trailerNumberPlateEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="trailerNumberPlate" formControlName="trailerNumberPlate"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="swapTrailerNumberEnabled"
                            formControlName="swapTrailerNumberEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="swapTrailerNumber" formControlName="swapTrailerNumber"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="driverEnabled"
                            formControlName="driverEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.driver"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="driver" formControlName="driver"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="coDriverEnabled"
                            formControlName="coDriverEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.co-driver"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="coDriver" formControlName="coDriver"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="carrierEnabled"
                            formControlName="carrierEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.carrier"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="carrier" formControlName="carrier"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="supplierEnabled"
                            formControlName="supplierEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.supplier"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="supplier" formControlName="supplier"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="identityCardEnabled"
                            formControlName="identityCardEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.identity-card"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="identityCard" formControlName="identityCard"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="mailEnabled"
                            formControlName="mailEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.mail"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="mail" formControlName="mail"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="resourcesEnabled"
                            formControlName="resourcesEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.data-protection-rules.resources"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="resources" formControlName="resources"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                </sc-flex>
            </div>
        </div>

        <ng-template masterDetailToolbar>
              <sc-cancel-button type="button" class="config-changed-button" (click)="cancel()"
              [disabled]="!cancelEnabled"></sc-cancel-button>
            <sc-content-spacer></sc-content-spacer>
              <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
              [disabled]="!saveEnabled"></sc-save-button>
        </ng-template>

    </sc-master-detail>

</div>
